<template>
    <a-modal v-model="visible" :title="data?.title" :width="formJson?.config.width > 800 ? formJson.config.width : 800"
        centered destroyOnClose @ok="doSubmit()">
        <template v-if="formJson != null">
            <k-form-build ref="kfb" :value="formJson" />
        </template>
    </a-modal>
</template>

<script>
import formUtils from '@/common/formUtils';
import utils from '@/common/utils';


export default {
    data() {
        return {
            visible: false,
            loading: false,
            data: null,
            formJson: null
        }
    },
    methods: {
        doSubmit() {
            this.$refs.kfb.getData().then(ret => {
                // console.log(ret)
                let data = { colId: this.data.colId, formData: JSON.stringify(ret) };
                utils.showSpin();
                this.http.post('/platform/collection/post', data).then(ret => {
                    // console.log(ret);
                    this.$emit('success');
                    this.close();
                })
            })
        },
        close() {
            this.data = null;
            this.formJson = null;
            this.visible = false;
        },
        show(data) {
            this.data = JSON.parse(JSON.stringify(data));
            this.getFormData();
        },
        //获取表单信息
        getFormData() {
            utils.showSpin();
            this.http.get('/platform/collection/getFromJson', { formId: this.data.formId }).then(ret => {
                console.log(ret)
                this.formJson = ret.data;
                this.visible = true;
            })
        }
    }
}
</script>

<style></style>